import { all, takeLatest, put } from 'redux-saga/effects';

import {
  types,
  sendGtmEventSuccess,
  sendGtmEventError,
} from '../redux/googleTagManager';

export function* sendGtmEvent(action) {
  const { eventName } = action.payload;
  try {
    const event = {
      event: eventName,
    };

    const dataLayer = window.dataLayer || [];
    dataLayer.push(event);
    yield put(sendGtmEventSuccess());
  } catch (err) {
    yield put(sendGtmEventError(err.message));
  }
}

export default function* () {
  yield all([takeLatest(types.SEND_GTM_EVENT, sendGtmEvent)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/googleTagManager.js